import { fontSize, fontWeight } from '@greasemap/design';

/** Props for {@link Text}. */
export interface TextProps {
  readonly children: React.ReactNode;
  /** Size from the type scale. Defaults to `md`. */
  readonly size?: keyof typeof fontSize;
  /** Weight from the type scale. Defaults to `regular`. */
  readonly weight?: keyof typeof fontWeight;
  /** Render secondary text using the muted colour role. */
  readonly muted?: boolean;
  /** Element to render. Defaults to `p`. */
  readonly as?: 'p' | 'span' | 'div';
}

/**
 * Body text.
 *
 * @param props - Component props.
 * @returns The text element.
 */
export function Text({
  children,
  size = 'md',
  weight = 'regular',
  muted = false,
  as: Component = 'p',
}: TextProps): React.JSX.Element {
  return (
    <Component
      className={muted ? 'gm-text-muted' : undefined}
      style={{ fontSize: `${fontSize[size]}px`, fontWeight: fontWeight[weight], margin: 0 }}
    >
      {children}
    </Component>
  );
}
